import i18next from 'i18next';
import API from '../../../../../../utils/api';
import { CHARTAPI } from '../../../../../constants/TRADEAPIKEYS';
import throttle from 'lodash/throttle';
import { CustomDatafeed } from '@app/organisms/Trade/TradeChart/TradeChartSection/ChartContainer/CustomDatafeed.tsx';
import { getChartOverrides } from '@/utils/chartThemeUtils';
import { ChartColorTheme } from '@/constants/chartThemes';

/* eslint-disable @typescript-eslint/no-unused-vars */
export const getLanguageFromURL = () => {
  const regex = new RegExp('[\\?&]lang=([^&#]*)');
  const results = regex.exec(window.location.search);
  return results === null
    ? null
    : decodeURIComponent(results[1].replace(/\+/g, ' '));
};

export const widgetOptions = (
  tvWidgetRef,
  paris,
  ep_id,
  updatechart,
  mutateUpdateChart,
  tab,
  lang,
  isDarkMode,
  token,
  exchangePairs = [],
  exchangeData = [],
  symbolSelectCallback,
  chartTheme?: ChartColorTheme
) => {
  const datafeed = CustomDatafeed;

  const resolutionIntervalMap = (interval) => {
    if (!interval) return '1';

    const resolutionsToIntervals = {
      '1m': '1',
      '3m': '3',
      '5m': '5',
      '15m': '15',
      '30m': '30',
      '1h': '60',
      '2h': '120',
      '4h': '240',
      '6h': '360',
      '8h': '480',
      '12h': '720',
      '1d': '1d',
      '1w': '1w',
      '1M': '1M',
    };
    return resolutionsToIntervals[interval] || '1';
  };

  return {
    symbol: paris || 'BTC/USDT',
    datafeed: datafeed,
    interval: resolutionIntervalMap(tab) || '1',
    container: 'tv_chart_container',
    library_path: '/charting_library/',
    locale: i18next.language === 'ko' ? 'ko' : 'en',
    auto_save_delay: 1,
    load_last_chart: true,
    favorites: {
      intervals: ['1', '5', '15', '30', '60', '1D', '1W', '1M'],
      indicators: ['Awesome Oscillator', 'Bollinger Bands'],
      drawingTools: ['LineToolBrush', 'LineToolCallout', 'LineToolCircle'],
      chartTypes: ['Area', 'Candles'],
    },
    disabled_features: [
      'timeframes_toolbar',
      'volume_force_overlay',
      'show_logo_on_all_charts',
      'caption_buttons_text_if_possible',
      'header_compare',
      'compare_symbol',
      'header_widget_dom_node',
      'header_undo_redo',
      'header_interval_dialog_button',
      'border_around_the_chart',
      'show_interval_dialog_on_key_press',
      'study_templates',
      'use_localstorage_for_settings',
      'header_settings',
      // "header_resolutions",
      'header_symbol_search', //mobile && 'left_toolbar',
    ],
    enabled_features: ['countdown', 'items_favoriting', 'symbol_search'],
    request_only_visible_range_on_reset: true,
    studies_overrides: {
      // Volume 색상
      'volume.volume.color.0': chartTheme?.colors.volumeDownColor || '#F71053',
      'volume.volume.color.1': chartTheme?.colors.volumeUpColor || '#37A16A',

      // MA CROSS (EMA) 색상
      // EMA는 TradingView 기본 색상 사용 (자동 할당)
      // 또는 수동으로 차트에서 색상 조정 가능
    },
    save_load_adapter: {
      charts: [] as any,
      studyTemplates: [] as any,
      drawingTemplates: [] as any,
      chartTemplates: [] as any,

      saveStorage() {
        window.localStorage.setItem('tv-charts', JSON.stringify(this.charts));
      },

      saveStorageTemplate() {
        console.log('saveStorageTemplate', this.studyTemplates);

        window.localStorage.setItem(
          'tv-chart-templates',
          JSON.stringify(this.chartTemplates)
        );
        window.localStorage.setItem(
          'tv-study-templates',
          JSON.stringify(this.studyTemplates)
        );
        window.localStorage.setItem(
          'tv-drawing-templates',
          JSON.stringify(this.drawingTemplates)
        );
      },

      getAllCharts: function () {
        const charttemp = window.localStorage.getItem('tv-charts');
        if (charttemp) {
          this.charts = JSON.parse(charttemp);
        }
        return Promise.resolve(this.charts);
      },

      removeChart: function (id) {
        const _this = this;
        setTimeout(() => {
          _this.saveStorage();
        }, 1000);

        for (let i = 0; i < this.charts.length; ++i) {
          if (this.charts[i].id === id) {
            console.log('DELETE22222', id);
            this.charts.splice(i, 1);
            return Promise.resolve();
          }
        }

        return Promise.reject();
      },

      saveChart: function (chartData: any) {
        if (!chartData.id) {
          chartData.id = Math.random().toString();
        } else {
          this.removeChart(chartData.id);
        }

        this.charts.push(chartData);

        this.saveStorage();

        return Promise.resolve(chartData.id);
      },

      getChartContent: function (id) {
        for (let i = 0; i < this.charts.length; ++i) {
          if (this.charts[i].id === id) {
            return Promise.resolve(this.charts[i].content);
          }
        }
        return Promise.reject();
      },

      removeStudyTemplate: function (studyTemplateData: any) {
        const _this = this;
        setTimeout(() => {
          _this.saveStorageTemplate();
        }, 1000);

        for (let i = 0; i < this.studyTemplates.length; ++i) {
          if (this.studyTemplates[i].name === studyTemplateData.name) {
            this.studyTemplates.splice(i, 1);
            return Promise.resolve();
          }
        }
        return Promise.reject();
      },

      getStudyTemplateContent: function (studyTemplateData) {
        for (let i = 0; i < this.studyTemplates.length; ++i) {
          if (this.studyTemplates[i].name === studyTemplateData.name) {
            return Promise.resolve(this.studyTemplates[i]);
          }
        }
        return Promise.reject();
      },

      saveStudyTemplate: function (studyTemplateData) {
        for (let i = 0; i < this.studyTemplates.length; ++i) {
          if (this.studyTemplates[i].name === studyTemplateData.name) {
            this.studyTemplates.splice(i, 1);
            break;
          }
        }

        this.studyTemplates.push(studyTemplateData);
        this.saveStorageTemplate();
        console.log('saveStudyTemplate', studyTemplateData);

        return Promise.resolve();
      },

      getAllStudyTemplates: function () {
        const studytemp = window.localStorage.getItem('tv-study-templates');
        this.studyTemplates = studytemp ? JSON.parse(studytemp) : [];

        console.log('getAllStudyTemplates', this.studyTemplates);
        return Promise.resolve(this.studyTemplates);
      },

      removeDrawingTemplate: function (toolName, templateName) {
        const _this = this;
        setTimeout(() => {
          _this.saveStorageTemplate();
        }, 1000);
        for (let i = 0; i < this.drawingTemplates.length; ++i) {
          if (this.drawingTemplates[i].name === templateName) {
            this.drawingTemplates.splice(i, 1);
            return Promise.resolve();
          }
        }

        return Promise.reject();
      },

      loadDrawingTemplate: function (toolName, templateName) {
        console.log('loadDrawingTemplate', toolName, templateName);
        const drawingtemp = window.localStorage.getItem('tv-drawing-templates');
        this.drawingTemplates = drawingtemp ? JSON.parse(drawingtemp) : [];

        for (let i = 0; i < this.drawingTemplates.length; ++i) {
          if (this.drawingTemplates[i].name === templateName) {
            return Promise.resolve(this.drawingTemplates[i].content);
          }
        }
        return Promise.reject();
      },

      saveDrawingTemplate: function (toolName, templateName, content) {
        for (let i = 0; i < this.drawingTemplates.length; ++i) {
          if (this.drawingTemplates[i].name === templateName) {
            this.drawingTemplates.splice(i, 1);
            break;
          }
        }

        this.drawingTemplates.push({
          name: templateName,
          content: content,
        });

        this.saveStorageTemplate();
        return Promise.resolve();
      },

      getDrawingTemplates: function () {
        console.log('getDrawingTemplates');
        const drawingtemp = window.localStorage.getItem('tv-drawing-templates');
        this.drawingTemplates = drawingtemp ? JSON.parse(drawingtemp) : [];

        return Promise.resolve(
          this.drawingTemplates.map(function (template) {
            return template.name;
          })
        );
      },
    },
    overrides: chartTheme ? getChartOverrides(chartTheme) : {
      'candleStyle.upColor': '#37A16A',
      'candleStyle.downColor': '#F71053',
      'candleStyle.wickUpColor': '#37A16A',
      'candleStyle.wickDownColor': '#F71053',
      'candleStyle.borderUpColor': '#37A16A',
      'candleStyle.borderDownColor': '#F71053',
      'candleStyle.volumeUpColor': '#37A16A',
      'candleStyle.volumeDownColor': '#F71053',
      'plotLineColor.priceLine.long': '#37A16A',
      'plotLineWidth.priceLine.long': 2,
      'plotLineColor.priceLine.short': '#F71053',
      'plotLineWidth.priceLine.short': 2,
      'mainSeriesProperties.showCountdown': true,
    },

    client_id: 'FossX',
    timezone: 'Asia/Seoul',
    charts_storage_url: 'https://saveload.tsaaaccccee.uk',
    charts_storage_api_version: '1.1',
    user_id: 'FossX' + token,
    fullscreen: false,
    autosize: true,
    theme: isDarkMode ? 'dark' : 'light',
    volume_precision: 0,
  };
};
